import React, { useState, useEffect } from "react";

import {
    Box,
    Grid,
    Button,
    Card,
    styled,
    Divider,
} from '@mui/material';

import { useNavigate } from "react-router-dom";

import { useReportContext } from "../../../context/ReportContext";
import { useReportDeliveryOrderExcelExport } from "../../../hooks/reports/sales/useReportDeliveryOrderExcelExport";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from '../../common/CommonRestricted';

import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

import { ReportBasicFilters, ReportAdvancedFilters } from "../filters/ReportFilters";
import { BasicFilter, AdvancedFilter } from "../filters/sales/FilterSalesOrder";


const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const RenderFormSearch = () => {

    const {
        t,
        formik,
        RenderToolbar,
        handleExport
    } = useReportContext()

    const { values, errors, touched, handleChange, setFieldValue, handleSubmit } = formik;
    const { generateExcel } = useReportDeliveryOrderExcelExport();
    const excelFileName = 'Delivery Orders.xlsx';
    const processHandleExport = async () => handleExport({ formik, generateExcel, excelFileName });

    return (
          <Box>
              <form onSubmit={handleSubmit}>
                  <StyledCard>
                      <Grid container spacing={0}>

                          <Grid item xs={12} sm={12} md={5.5}>
                              <ReportBasicFilters>
                                  <BasicFilter/>
                              </ReportBasicFilters>
                          </Grid>

                          <Grid item xs={0} sm={0} md={0.5} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                              <Divider orientation="vertical"/>
                          </Grid>

                          <Grid item xs={12} sm={12} md={6}>
                              <ReportAdvancedFilters>
                                  <AdvancedFilter/>
                              </ReportAdvancedFilters>
                          </Grid>

                      </Grid>
                  </StyledCard>

                  <RenderToolbar
                        handleExport={processHandleExport}
                  />

              </form>
          </Box>
    )
}

const RenderBreadcumbs = ({
    navigate
}) => {

    const { t, availableReports, getRoute, routeType, availableReportScope } = useReportContext()

    let actionMenus = []

    Object.keys(availableReports).forEach(i => {

        let item = availableReports[i]

        actionMenus.push({
            displayText: t(item.display),
            onClick: () => {
                navigate(getRoute(`reports/${availableReportScope}/${item.id}`))
            }
        })
    })

    return (
          <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("deliveryOrderReport")}
                actionMenus={actionMenus}
                breadcrumbs={[
                    {
                        displayText: t("reports"),
                        props: {
                            // underline: "hover",
                            // href: getRoute('documents/cashSales')
                        }
                    },
                    {
                        displayText: t("deliveryOrderReport"),
                        props: {
                            // disabled: true,
                            color: 'secondary.main',
                        }
                    },
                ]}
          />
    )
}

const RenderReportDataDisplay = () => {

    const {
        t,
        RenderReportData
    } = useReportContext()

    const columns = [
        { field: 'no', headerName: t('number'), flex: 0.3 },
        { field: 'location_name', headerName: t('location'), flex: 1 },
        { field: 'doc_number', headerName: t('docNo'), flex: 1 },
        { field: 'doc_date', headerName: t('docDate'), flex: 1 },
        { field: 'profile_name', headerName: t('profile'), flex: 1 },
        { field: 'address_1', headerName: t('address1'), flex: 1 },
        { field: 'address_2', headerName: t('address2'), flex: 1 },
        { field: 'postcode', headerName: t('postcode'), flex: 1 },
        { field: 'area_name', headerName: t('area'), flex: 1 },
        { field: 'state_name', headerName: t('state'), flex: 1 },
        { field: 'country_name', headerName: t('country'), flex: 1 },
        { field: 'ax_createusername', headerName: t('createdBy'), flex: 1 },
        { field: 'ax_createdatetime', headerName: t('createdDateTime'), flex: 1 },
    ]

    return (
          <RenderReportData
                columns={columns}
          />
    )
}

const RenderMain = () => {

    return (
          <Box>

              <Grid container spacing={1}>

                  <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                      <RenderFormSearch/>
                  </Grid>

              </Grid>

              <RenderReportDataDisplay/>

          </Box>
    )
}

export default function ReportDeliveryOrder({
    routeType
}) {

    const navigate = useNavigate();
    const { getHtmlHead } = useSystemHead(routeType)

    const {
        t,
        formik,
    } = useReportContext()

    const { isPermissionAllow } = usePermissions(routeType, scopeIds.report.id, scopeTypes.report.delivery.id)

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    return (
          <Box>
              {
                  getHtmlHead({ routeType, title: headTitles.deliveryReports })
              }

              <RenderBreadcumbs
                    navigate={navigate}
              />

              {
                  isPermissionAllow({ functionType: functionTypes.pageView.id }) ?
                        <RenderMain/>
                        :
                        <CommonRestricted/>
              }

              {/* {JSON.stringify(values)}
            {JSON.stringify(errors)} */}

          </Box>
    )
}